import { createSlice } from '@reduxjs/toolkit';

export const messagesI18nSlice = createSlice({
  name: 'messagesI18n',
  initialState: {
    messages: []
  },
  reducers: {
    setMessagesI18n: (state, action) => {
      state.messages = action.payload;
    }
  },
  selectors: {
    selectMessagesI18n: (state) => state.messages
  }
});

export const { setMessagesI18n } = messagesI18nSlice.actions;

export const { selectMessagesI18n } = messagesI18nSlice.selectors;

export default messagesI18nSlice.reducer;
